'use strict';

function arrayWrap(obj) {
  var arr = [];
  arr.push(obj);
  return arr;
}

module.exports = arrayWrap;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/internal/arrayWrap.js
// module id = 394
// module chunks = 0